// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"52719153","977":"9cb4cec4"}[chunkId] + ".chunk.js";
};